import { Box, Grid } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import ClientContractsCreditsAndRebatesTable from './dataTables/clientContractsCreditsAndRebatesTable.component';
import ClientContractsSLATable from './dataTables/clientContractsSLATable.component';
import ClientTaxesAndOtherInfoCard from './dataTables/clientTaxesAndOtherInfoCard.component';

import PropTypes from 'prop-types';
import React from 'react';

const ClientContractsTab = ({ formikProps, enumerations, clientDetails, isReadOnly = false }) => {
  return (
    <Box sx={{ padding: '20px' }}>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} md={8} rowSpacing={2}>
          <ClientContractsSLATable clientId={clientDetails.clientDetails.clientRecordId} enumerations={enumerations.allEnums} hideEdit={isReadOnly}  />
          <Box sx={{ paddingTop: '16px' }}>
            <ClientContractsCreditsAndRebatesTable clientId={clientDetails.clientDetails.clientRecordId} enumerations={enumerations.allEnums} hideEdit={isReadOnly} />
          </Box>
        </Grid>
        <Grid item xs={12} md={4} rowSpacing={2}>
          <ClientTaxesAndOtherInfoCard formikProps={formikProps} clientDetails={clientDetails.clientDetails} enumerations={enumerations.allEnums}/>
          {/* <Box sx={{ paddingTop: '16px' }}>
            <ClientBankingInfoCard formikProps={formikProps} clientBanks={clientDetails.clientBanks} enumerations={enumerations.allEnums} />
          </Box>           */}
        </Grid>
      </Grid>
    </Box>
  );
};

ClientContractsTab.propTypes = {
  formikProps: PropTypes.object.isRequired,
  clientContractsSLA: PropTypes.array,
  clientContractsCreditsAndRebates: PropTypes.array,
  clientDetails: PropTypes.object.isRequired

};

const mapStateToProps = (state) => {
  const { clientContractsSLA, clientContractsCreditsAndRebates, clientDetails } = state.clients.clientsInfo[state.clients.currentClientId];

  return {
    clientContractsSLA,
    clientContractsCreditsAndRebates,
    clientDetails
  };
};

  
export default compose(
  connect(mapStateToProps),
)(ClientContractsTab);